<template>
    <div>
        <DForm>
            <DCard
                padding
                :title="__('tools.providerbox.modules_title')"
            >
                <DFormRow
                    :label="__('tools.providerbox.form.module')"
                    :error="errors.modules"
                    is-required
                >
                    <DMultiSelect
                        id="fulfillment_modules"
                        :options="modules"
                        selection-type="tags"
                        :multiple="true"
                        :selection="true"
                        inline
                        @update="updateModuleOptions"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.providerbox.form.customer_type')"
                    :error="errors.customer_type"
                    is-required
                >
                    <DSelect
                        id="customer_type"
                        v-model="form.customer_type"
                        :placeholder="__('tools.providerbox.form.customer_type')"
                        :options="customerTypes"
                        :is-valid="isFormFieldValid('customer_type')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.providerbox.form.period')"
                    :error="errors.period"
                    is-required
                >
                    <DInput
                        id="period"
                        v-model="form.period"
                        type="month"
                        :placeholder="__('tools.providerbox.form.period_placeholder')"
                        :is-valid="isFormFieldValid('period')"
                    />
                </DFormRow>
            </DCard>
            <DCard
                padding
                :title="__('tools.providerbox.customer_exception_title')"
                class="mt-2"
            >
                <DFormRow
                    v-for="module in modules"
                    :key="module"
                    :label="module.text"
                    :error="errors['module_exceptions.' + module.value]"
                >
                    <DFormTextarea
                        :id="`module_exceptions_${module.value}`"
                        v-model="form.module_exceptions[module.value]"
                        :placeholder="module.text"
                        :is-valid="isFormFieldValid('module_exceptions.' + module.value)"
                    />
                </DFormRow>
            </DCard>
        </DForm>
        <DFabs>
            <DFab
                id="btn-release"
                :icon="'content-save'"
                :label="__('messages.save')"
                @click="submitForm()"
            />
        </DFabs>
    </div>
</template>

<script>
export default {
    name: 'ImportIndex',
    props: {
        modules: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        importHistory: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    data () {
        return {
            form: this.$inertia.form({
                modules: [],
                customer_type: null,
                period: null,
                module_exceptions: {
                    exchange: this.importHistory.exchange ?? null,
                    exchange2010: this.importHistory.exchange2010 ?? null,
                    exchange2013: this.importHistory.exchange2013 ?? null,
                    spam: this.importHistory.spam ?? null,
                    virtuelle_server: this.importHistory.virtuelle_server ?? null,
                    backup: this.importHistory.backup ?? null,
                    domainrobot: this.importHistory.domainrobot ?? null,
                    monitoring: this.importHistory.monitoring ?? null,
                    jelastic: this.importHistory.jelastic ?? null
                }
            })
        }
    },
    methods: {
        submitForm () {
            this.form.post(this.$route('tools.providerbox.import'))
        },
        updateModuleOptions (values) {
            this.form.modules = values
        }
    }
}
</script>

<style scoped>

</style>
